import React from "react";

export default function GoogleLoginIcon() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.8055 22.0415H33V22H24V26H29.6515C28.827 28.3285 26.6115 30 24 30C20.6865 30 18 27.3135 18 24C18 20.6865 20.6865 18 24 18C25.5295 18 26.921 18.577 27.9805 19.5195L30.809 16.691C29.023 15.0265 26.634 14 24 14C18.4775 14 14 18.4775 14 24C14 29.5225 18.4775 34 24 34C29.5225 34 34 29.5225 34 24C34 23.3295 33.931 22.675 33.8055 22.0415Z"
        fill="#FFC107"
      />
      <path
        d="M15.153 19.3455L18.4385 21.755C19.3275 19.554 21.4805 18 24 18C25.5295 18 26.921 18.577 27.9805 19.5195L30.809 16.691C29.023 15.0265 26.634 14 24 14C20.159 14 16.828 16.1685 15.153 19.3455Z"
        fill="#FF3D00"
      />
      <path
        d="M24 34.0001C26.583 34.0001 28.93 33.0116 30.7045 31.4041L27.6095 28.7851C26.5717 29.5743 25.3037 30.0011 24 30.0001C21.399 30.0001 19.1905 28.3416 18.3585 26.0271L15.0975 28.5396C16.7525 31.7781 20.1135 34.0001 24 34.0001Z"
        fill="#4CAF50"
      />
      <path
        d="M33.8055 22.0415H33V22H24V26H29.6515C29.2571 27.1082 28.5467 28.0766 27.608 28.7855L27.6095 28.7845L30.7045 31.4035C30.4855 31.6025 34 29 34 24C34 23.3295 33.931 22.675 33.8055 22.0415Z"
        fill="#1976D2"
      />
      <circle cx="24" cy="24" r="23.5" stroke="#CCCCCC" />
    </svg>
  );
}
